"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhatsAppDmContact = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const nest_interconnectors_1 = require("@rws-framework/nest-interconnectors");
const component_1 = require("@front/components/site-menu/component");
const WhatsAppAgentService_1 = __importStar(require("@front/services/WhatsAppAgentService"));
//@ts-ignore                
let rwsTemplate = T.html `<div class="whatsapp-dm-detail container-fluid">
    <div class="comms-group-list-header mb-4">
        <h1>
            <i class="simple-icon-user mr-2 wa-green-text"></i>${x => x.contactName || 'whatsapp.dm.loading'.t()}
            ${(0, fast_element_1.when)(x => x.communicationType, (0, fast_element_1.html) `
                <span class="badge-comms-type ${x => x.communicationType === 'TELE' ? 'tele' : 'wa'}">${x => x.communicationType === 'TELE' ? 'whatsapp.dm.communicationType.tele'.t() : 'whatsapp.dm.communicationType.wa'.t()}</span>
            `)}
        </h1>
        <div class="comms-group-list-actions text-zero top-right-button-container">
            <button @click="${x => x.goBack()}" type="button"
              class="top-right-button mr-1 btn btn-primary btn-lg">${'whatsapp.dm.back'.t()}</button>
        </div>
    </div>

    ${(0, fast_element_1.when)(x => x.agentChecking && !x.loading, (0, fast_element_1.html) `
        <div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
            <span class="spinner-border spinner-border-sm mr-2"></span>
            ${'whatsapp.groups.agentChecking'.t()}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.agentChecking && !x.agentActive && !x.loading, (0, fast_element_1.html) `
        <div class="alert alert-danger d-flex align-items-center mb-3" role="alert">
            <i class="simple-icon-ban mr-2"></i>
            ${'whatsapp.groups.agentOffline'.t()}
        </div>
    `)}

    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
        <app-loader></app-loader>
    `)}

    ${(0, fast_element_1.when)(x => !x.loading, (0, fast_element_1.html) `
        <div class="row">

            
            <div class="col-lg-4">
                <div class="comms-group-list-contact-info card mb-4">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-info mr-2 info-text"></i>${'whatsapp.dm.contactInfo'.t()}</h5>
                    </div>
                    <div class="card-body">
                        <div class="p-3 card mb-2 contact-info-card-primary">
                            <small class="text-muted d-block mb-1">${'whatsapp.dm.contactName'.t()}</small>
                            <strong>${x => x.contactName || x.authorLid}</strong>
                        </div>
                        <div class="p-3 card contact-info-card-secondary">
                            <small class="text-muted d-block mb-1">${'whatsapp.dm.contactId'.t()}</small>
                            <span class="small font-monospace text-secondary word-break-all">${x => x.authorLid}</span>
                        </div>
                    </div>
                </div>

                
                <div class="comms-group-list-summaries card mb-4">
                    <div class="card-header bg-light py-3">
                        <h5 class="card-title mb-0"><i class="simple-icon-doc mr-2 primary-text"></i>${'whatsapp.dm.summaries.title'.t()}</h5>
                    </div>
                    <div class="card-body p-0">
                        ${(0, fast_element_1.when)(x => x.summariesLoading, (0, fast_element_1.html) `
                            <div class="text-center p-3"><app-loader block="true" width="15px" height="15px"></app-loader></div>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.summariesLoading && x.summaries.length === 0, (0, fast_element_1.html) `
                            <p class="text-muted text-center p-4">${'whatsapp.dm.summaries.empty'.t()}</p>
                        `)}
                        ${(0, fast_element_1.when)(x => !x.summariesLoading && x.summaries.length > 0, (0, fast_element_1.html) `
                            <table class="table table-striped table-hover mb-0 small summaries-table">
                                <thead>
                                    <tr>
                                        <th class="text-nowrap"><i class="simple-icon-calendar mr-1"></i>${'whatsapp.dm.summaries.date'.t()}</th>
                                        <th>${'whatsapp.dm.summaries.excerpt'.t()}</th>
                                        <th class="text-end" style="width: 50px;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${(0, fast_element_1.repeat)(x => x.summaries, (0, fast_element_1.html) `
                                        <tr>
                                            <td class="text-nowrap">${x => x.dateKey}</td>
                                            <td class="text-muted">${(x, c) => c.parent.getSummaryExcerpt(x)}</td>
                                            <td class="text-end">
                                                <button type="button" class="btn btn-outline-info btn-sm icon-btn"
                                                        @click="${(x, c) => c.parent.showSummary(x)}">
                                                    <i class="simple-icon-eye"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    `)}
                                </tbody>
                            </table>
                        `)}
                    </div>
                </div>
            </div>

            
            <div class="col-lg-8">
                <comms-messages
                    mode="dm"
                    :settingsId="${x => x.settingsId}"
                    :authorLid="${x => x.authorLid}"
                    :phoneNumber="${x => x.phoneNumber || ''}"
                    :communicationType="${x => x.communicationType}"
                    :agentActive="${x => x.agentActive}"
                    :contactName="${x => x.contactName}"
                    @summary-created="${(x, c) => x.handleSummaryCreated(c.event)}"
                    @contact-name-discovered="${(x, c) => x.handleContactNameDiscovered(c.event)}"
                ></comms-messages>
            </div>
        </div>
    `)}
</div>

${(0, fast_element_1.when)(x => !!x.selectedSummary, (0, fast_element_1.html) `
    <div class="summary-drawer-overlay" @click="${x => x.closeSummaryModal()}"></div>
    <aside class="summary-drawer">
        <div class="p-3 border-bottom d-flex align-items-center justify-content-between">
            <div>
                <h5 class="mb-1 font-weight-bold">${'whatsapp.dm.summaries.modalTitle'.t()}</h5>
                <p class="mb-0 small text-muted">${x => { var _a; return (_a = x.selectedSummary) === null || _a === void 0 ? void 0 : _a.dateKey; }}</p>
            </div>
            <button type="button" class="close" @click="${x => x.closeSummaryModal()}" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="p-3 summary-drawer-body" :innerHTML="${x => { var _a; return (_a = x.selectedSummary) === null || _a === void 0 ? void 0 : _a.summaryText; }}"></div>
    </aside>
`)}`;
require("./styles/layout.scss");
const styles = T.css `.wa-groups-dashboard {
  display: flex;
  height: calc(100vh - 200px);
  min-height: 500px;
  overflow: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
}

.wa-gd-sidebar {
  width: 320px;
  flex-shrink: 0;
  background: #fff;
  border-right: 1px solid #d7d7d7;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wa-gd-sidebar-header {
  flex-shrink: 0;
}

.wa-gd-search {
  padding-left: 30px !important;
  border: 1px solid #d7d7d7 !important;
}

.wa-gd-filter-btn {
  flex: 1;
  padding: 5px 4px;
  border: 1px solid #d7d7d7;
  background: #f5f6f8;
  color: #333;
  font-size: 0.72rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.12s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}
.wa-gd-filter-btn:first-child {
  border-radius: 4px 0 0 4px;
}
.wa-gd-filter-btn:last-child {
  border-radius: 0 4px 4px 0;
  border-left: none;
}
.wa-gd-filter-btn:not(:first-child) {
  border-left: none;
}
.wa-gd-filter-btn:hover {
  background: #ececec;
}
.wa-gd-filter-btn.active {
  background: #3b82f6;
  color: #fff;
  font-weight: 700;
  border-color: #2563eb;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.15);
}
.wa-gd-filter-btn.active .wa-gd-count {
  color: rgba(255, 255, 255, 0.8);
}

.wa-gd-count {
  font-weight: normal;
  color: #888;
  font-size: 0.68rem;
}

.wa-gd-sidebar-list {
  flex: 1;
  overflow-y: auto;
}

.wa-gd-sidebar-item {
  display: block;
  width: 100%;
  padding: 11px 14px;
  border: none;
  border-bottom: 1px solid #f0f0f0;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: all 0.12s ease;
}
.wa-gd-sidebar-item:hover {
  background: #f5f5f5;
}

.wa-gd-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: #fff;
  flex-shrink: 0;
}

.wa-gd-sidebar-footer {
  flex-shrink: 0;
}

.wa-gd-center {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px 16px;
}

.wa-gd-stat-card {
  padding-top: 0 !important;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.wa-gd-messages-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wa-gd-messages-panel .card-header {
  flex-shrink: 0;
}

.wa-gd-messages-body {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 440px;
  background: #f8f9fa;
}

.wa-gd-msg-list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 6px;
}

.wa-gd-msg-item {
  background: #fff;
  border-radius: 6px;
  padding: 7px 10px;
  border: 1px solid #e9ecef;
  font-size: 0.82rem;
  line-height: 1.4;
}
.wa-gd-msg-item .wa-gd-msg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}
.wa-gd-msg-item .wa-gd-msg-sender {
  font-weight: 600;
  color: #28a745;
}
.wa-gd-msg-item .wa-gd-msg-time {
  color: #adb5bd;
  font-size: 0.72rem;
  margin-left: auto;
  flex-shrink: 0;
}
.wa-gd-msg-item .wa-gd-msg-body {
  color: #343a40;
  word-break: break-word;
}

.wa-gd-tracklogs-section {
  background: #fff;
}

.wa-gd-tracklogs-header {
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa !important;
}

.wa-gd-tracklogs-list {
  overflow-y: auto;
}

.wa-gd-tracklog-item {
  font-size: 0.8rem;
  background: #fff;
  transition: all 0.12s ease;
}
.wa-gd-tracklog-item:last-child {
  border-bottom: none !important;
}
.wa-gd-tracklog-item:hover {
  background: #f8f9fa;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.loading_groups {
  margin-top: 50px;
  text-align: center;
  color: #888;
}

.whatsapp-dm-detail {
  width: 100%;
}
.whatsapp-dm-detail .top-right-button-container {
  float: right;
}

.comms-group-list-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}
.comms-group-list-header h1 {
  margin-bottom: 0;
}

.comms-group-list-actions {
  flex-shrink: 0;
}

.comms-group-list-contact-info {
  padding-top: 0 !important;
}

.comms-group-list-summaries {
  padding-top: 0 !important;
}

.comms-group-list-messages {
  padding-top: 0 !important;
  display: flex;
  flex-direction: column;
}

.comms-group-list-messages-controls {
  flex-shrink: 0;
}

.comms-group-list-messages-list {
  flex: 1;
  overflow-y: auto;
  min-height: 260px;
  max-height: 500px;
}

.comms-group-list-send-message {
  padding-top: 0 !important;
}

.comms-group-list-members {
  padding-top: 0 !important;
}

.comms-group-list-add-participants {
  padding-top: 0 !important;
}

.comms-group-list-bot-settings {
  padding-top: 0 !important;
}

.card {
  padding-top: 1.5rem;
}

.summary-drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 1040;
}

.summary-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 500px;
  height: 100vh;
  background: #fff;
  box-shadow: -8px 0 28px rgba(0, 0, 0, 0.18);
  z-index: 1050;
  display: flex;
  flex-direction: column;
}
@media (max-width: 767.98px) {
  .summary-drawer {
    width: 100vw;
  }
}

.summary-drawer-body {
  overflow-y: auto;
  flex: 1;
}

.messages-list {
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.messages-list .message-item:nth-child(odd) {
  background-color: rgb(243, 243, 243) !important;
}

.message-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
}
.message-item:last-child {
  border-bottom: none;
}
.message-item--agent {
  background-color: #e8f5e9 !important;
}
.message-item__meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.message-item__sender {
  font-weight: 600;
  font-size: 0.85rem;
  color: #333;
}
.message-item__time {
  font-size: 0.75rem;
  color: #999;
}
.message-item__body {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
  word-break: break-word;
}
.message-item__media {
  margin-top: 8px;
}

.text-muted-small {
  font-size: 0.72rem;
  color: #888;
}

.text-truncate-max {
  max-width: 130px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.badge-comms-type {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-type.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-type.tele {
  background-color: #0088cc;
  color: #fff;
}

.badge-tracking {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.join-group-hint {
  color: #666;
  font-size: 0.9rem;
}

.join-group-modal-body {
  padding: 8px 0;
}

.wa-green-text {
  color: #25d366 !important;
}

.info-text {
  color: #17a2b8 !important;
}

.primary-text {
  color: #3b82f6 !important;
}

.success-text {
  color: #28a745 !important;
}

.warning-text {
  color: #ffc107 !important;
}

.danger-text {
  color: #dc3545 !important;
}

.text-secondary {
  color: #555 !important;
}

.contact-info-card-primary {
  background: #f0f9ff;
  border: 1px solid #bee3f8;
}
.contact-info-card-primary strong {
  font-size: 1.05rem;
  color: #1a1a2e;
}

.contact-info-card-secondary {
  background: #f8f9fa;
  border: 1px solid #e2e8f0;
}

.font-monospace {
  font-family: monospace;
}

.word-break-all {
  word-break: break-all;
}

.summaries-table th {
  white-space: nowrap;
}

.stat-icon-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}
.stat-icon-circle.success {
  background-color: rgba(40, 167, 69, 0.1);
  border: 1px solid rgba(40, 167, 69, 0.25);
  color: #28a745;
}
.stat-icon-circle.danger {
  background-color: rgba(220, 53, 69, 0.1);
  border: 1px solid rgba(220, 53, 69, 0.25);
  color: #dc3545;
}
.stat-icon-circle.warning {
  background-color: rgba(255, 193, 7, 0.1);
  border: 1px solid rgba(255, 193, 7, 0.25);
  color: #ffc107;
}
.stat-icon-circle.primary {
  background-color: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.25);
  color: #3b82f6;
}
.stat-icon-circle.info {
  background-color: rgba(23, 162, 184, 0.1);
  border: 1px solid rgba(23, 162, 184, 0.25);
  color: #17a2b8;
}

.sidebar-item-content {
  min-width: 0;
  flex: 1;
}
.sidebar-item-content .item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2px;
  gap: 8px;
}
.sidebar-item-content .item-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 130px;
}
.sidebar-item-content .item-badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
}
.sidebar-item-content .item-status {
  display: flex;
  align-items: center;
  gap: 3px;
}
.sidebar-item-content .status-dot-sm {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}
.sidebar-item-content .status-label {
  font-size: 0.68rem;
  font-weight: 600;
}
.sidebar-item-content .item-comment {
  font-size: 0.72rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.badge-tracking-sm {
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #198754;
  color: #fff;
}

.badge-comms-sm {
  font-size: 0.55rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
}
.badge-comms-sm.wa {
  background-color: #25d366;
  color: #fff;
}
.badge-comms-sm.tele {
  background-color: #0088cc;
  color: #fff;
}
.badge-comms-sm.email {
  background-color: var(--primary-color);
  color: #fff;
}

.badge-count-sm {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #6c757d;
  color: #fff;
}

.badge-count-info {
  font-size: 0.65rem;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  background-color: #17a2b8;
  color: #fff;
}

.wa-gd-tracklog-badge {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border-radius: 50rem;
  padding: 0.15em 0.5em;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.wa-gd-tracklog-badge.critical {
  background-color: #dc3545;
  color: #fff;
}
.wa-gd-tracklog-badge.warning {
  background-color: #ffc107;
  color: #212529;
}
.wa-gd-tracklog-badge.good {
  background-color: #28a745;
  color: #fff;
}
.wa-gd-tracklog-badge.neutral {
  background-color: #6c757d;
  color: #fff;
}

.card-header-icon {
  margin-right: 0.5rem;
}
.card-header-icon.success {
  color: #28a745;
}
.card-header-icon.primary {
  color: #3b82f6;
}
.card-header-icon.info {
  color: #17a2b8;
}
.card-header-icon.wa-green {
  color: #25d366;
}

.tracklog-title {
  font-size: 0.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.25rem;
}

.tracklog-summary {
  font-size: 0.75rem;
  line-height: 1.4;
  color: #888;
}

.tracklog-timestamp {
  font-size: 0.7rem;
  color: #888;
  flex-shrink: 0;
  margin-left: 0.5rem;
}

.tracklog-group-name {
  font-size: 0.7rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tracklog-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.tracklog-header-actions {
  display: flex;
  gap: 6px;
}

.card-header-title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0;
}

.handler-switch {
  display: inline-flex;
  align-items: center;
}

:host {
  display: block;
  width: 100%;
}`;
const shadowOptions = { "mode": "open" };
let WhatsAppDmContact = class WhatsAppDmContact extends client_1.RWSViewComponent {
    get allowedPhoneNumbersList() {
        return this.phoneNumbers || [];
    }
    constructor(wsService, waAgentService) {
        super();
        this.wsService = wsService;
        this.waAgentService = waAgentService;
        this.passedId = '';
        this.settingsId = '';
        this.phoneNumbers = [];
        this.loading = false;
        this.contactName = '';
        this.authorLid = '';
        this.agentActive = false;
        this.agentInitializing = false;
        this.agentChecking = false;
        this.summaries = [];
        this.summariesLoading = false;
        this.selectedSummary = null;
        this.phoneNumber = null;
        this.communicationType = 'WA';
        this._agentStatusUnsubscribe = null;
        this._wsUnsubscribers = [];
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        const combinedId = decodeURIComponent(((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id) || this.passedId || '');
        const separatorIdx = combinedId.indexOf('--');
        if (separatorIdx > -1) {
            this.settingsId = combinedId.substring(0, separatorIdx);
            const rawLid = combinedId.substring(separatorIdx + 2);
            this.authorLid = rawLid.includes('@') ? rawLid : `${rawLid}@lid`;
        }
        else {
            this.authorLid = combinedId.includes('@') ? combinedId : `${combinedId}@lid`;
        }
        const settingsResponse = (await this.apiService.back.get('whatsapp.settings.getById', { routeParams: { id: this.settingsId } }));
        if ((settingsResponse === null || settingsResponse === void 0 ? void 0 : settingsResponse.success) && settingsResponse.data) {
            this.phoneNumber = settingsResponse.data.phoneNumber;
            this.communicationType = settingsResponse.data.communicationType || 'WA';
            // Enforce phone-number filter on the frontend as well — when the
            // gate passes a list of allowed phone numbers, refuse to render
            // a DM contact whose settings phone number is not in the list.
            const allowed = this.allowedPhoneNumbersList;
            if (allowed.length > 0 && this.phoneNumber && !allowed.includes(this.phoneNumber)) {
                this.notifyService.notify('whatsapp.groups.gate.notAllowed'.t(), 'error');
                return;
            }
        }
        this.loading = true;
        await this.loadSummaries();
        this.loading = false;
        // Try to get contact name from summaries if available
        // (The comms-messages component will handle messages internally)
        if (this.summaries.length > 0) {
            // Contact name will be set by the comms-messages component via event
            // or we can try to get it from the first summary
        }
        this.setupWsListeners();
    }
    setupWsListeners() {
        // Listen for new DM track log
        this._wsUnsubscribers.push(this.wsService.listenForMessage('comms_point', async (wsResponse) => {
            const data = wsResponse === null || wsResponse === void 0 ? void 0 : wsResponse.data;
            if (!data || data.authorLid !== this.authorLid)
                return;
            await this.loadSummaries();
        }, 'comms_track_log_created'));
        if (this.phoneNumber) {
            this._agentStatusUnsubscribe = this.waAgentService.onStatusChange(this.phoneNumber, (active, initializing) => {
                this.agentActive = active;
                this.agentInitializing = initializing;
            });
            const phoneNumber = this.phoneNumber;
            this.agentChecking = true;
            setTimeout(async () => {
                const result = await this.waAgentService.checkAgentStatus(phoneNumber);
                const state = this.waAgentService.getPhoneState(phoneNumber);
                this.agentActive = state.active;
                this.agentInitializing = state.initializing;
                this.agentChecking = false;
            }, 1500);
        }
    }
    async loadSummaries() {
        this.summariesLoading = true;
        try {
            const response = await this.apiService.back.get('whatsapp.directMessages.summaries', {
                routeParams: {
                    settingsId: this.settingsId,
                    authorLid: encodeURIComponent(this.authorLid)
                }
            });
            if ((response === null || response === void 0 ? void 0 : response.success) && Array.isArray(response.data)) {
                this.summaries = response.data;
            }
            else {
                this.summaries = [];
            }
        }
        catch (e) {
            console.error(e);
            this.summaries = [];
        }
        finally {
            this.summariesLoading = false;
        }
    }
    showSummary(summary) {
        this.selectedSummary = summary;
    }
    closeSummaryModal() {
        this.selectedSummary = null;
    }
    getSummaryExcerpt(summary) {
        if (!(summary === null || summary === void 0 ? void 0 : summary.summaryText))
            return '';
        const text = summary.summaryText.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
        return text.length > 120 ? text.slice(0, 120) + '…' : text;
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/settings/comms');
    }
    /**
     * Handle summary-created event from comms-messages component.
     * Reloads summaries and shows the newly created one.
     */
    async handleSummaryCreated(event) {
        const detail = event.detail;
        if (!detail)
            return;
        await this.loadSummaries();
        const summary = this.summaries.find(s => s.id === detail.summaryId);
        this.showSummary(summary || null);
    }
    /**
     * Handle contact-name-discovered event from comms-messages component.
     * Sets the contact name when messages are loaded.
     */
    handleContactNameDiscovered(event) {
        const detail = event.detail;
        if (detail === null || detail === void 0 ? void 0 : detail.contactName) {
            this.contactName = detail.contactName;
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._wsUnsubscribers.forEach(off => off());
        this._wsUnsubscribers = [];
        if (this._agentStatusUnsubscribe) {
            this._agentStatusUnsubscribe();
            this._agentStatusUnsubscribe = null;
        }
    }
};
exports.WhatsAppDmContact = WhatsAppDmContact;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "passedId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "settingsId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Array)
], WhatsAppDmContact.prototype, "phoneNumbers", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppDmContact.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "contactName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "authorLid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppDmContact.prototype, "agentActive", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppDmContact.prototype, "agentInitializing", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppDmContact.prototype, "agentChecking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], WhatsAppDmContact.prototype, "summaries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], WhatsAppDmContact.prototype, "summariesLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IWhatsAppGroupSummaryData !== "undefined" && backendImport_1.IWhatsAppGroupSummaryData) === "function" ? _c : Object)
], WhatsAppDmContact.prototype, "selectedSummary", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "phoneNumber", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], WhatsAppDmContact.prototype, "communicationType", void 0);
exports.WhatsAppDmContact = WhatsAppDmContact = __decorate([
    (0, client_1.RWSView)('whatsapp-dm-contact', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(nest_interconnectors_1.WSService)),
    __param(1, (0, client_1.RWSInject)(WhatsAppAgentService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof nest_interconnectors_1.WSServiceInstance !== "undefined" && nest_interconnectors_1.WSServiceInstance) === "function" ? _a : Object, typeof (_b = typeof WhatsAppAgentService_1.WhatsAppAgentServiceInstance !== "undefined" && WhatsAppAgentService_1.WhatsAppAgentServiceInstance) === "function" ? _b : Object])
], WhatsAppDmContact);
WhatsAppDmContact.defineComponent();
exports.default = WhatsAppDmContact;
